module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "width": "650px",
      "set-class": "no-padding"
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('skipass.pricelist-title')))]), _vm._v(" "), (_vm.showTabs) ? _c('div', {
    staticClass: "tab-buttons"
  }, [_c('button', {
    class: 'small ' + (_vm.activeTab === 'weekday' ? 'blue' : 'white') + ' border',
    on: {
      "click": function($event) {
        return _vm.switchTab('weekday')
      }
    }
  }, [_vm._v("Vardag")]), _vm._v(" "), _c('button', {
    class: 'small ' + (_vm.activeTab === 'weekend' ? 'blue' : 'white') + ' border',
    on: {
      "click": function($event) {
        return _vm.switchTab('weekend')
      }
    }
  }, [_vm._v("Helg")]), _vm._v(" "), _c('button', {
    class: 'small ' + (_vm.activeTab === 'premiere' ? 'blue' : 'white') + ' border',
    on: {
      "click": function($event) {
        return _vm.switchTab('premiere')
      }
    }
  }, [_vm._v("Premiärhelg")])]) : _vm._e(), _vm._v(" "), _c('table', [_c('thead', [_c('th'), _vm._v(" "), _c('th', {
    staticClass: "special-price-wrapper--title"
  }), _vm._v(" "), (_vm.SITE_CONFIG.site !== 'branas' && _vm.SITE_CONFIG.site !== 'kungsberget') ? _c('th', [_c('b', [_vm._v("Barn")]), _c('br'), _vm._v(_vm._s(_vm.SITE_CONFIG.skipass.ages.children) + " år")]) : _vm._e(), _vm._v(" "), _c('th', [_c('b', [_vm._v(_vm._s(_vm.$t('general.ages.youth')))]), _c('br'), _vm._v(_vm._s(_vm.SITE_CONFIG.skipass.ages.youths) + "år")]), _vm._v(" "), _c('th', [_c('b', [_vm._v(_vm._s(_vm.$t('general.ages.adult')))]), _c('br'), _vm._v(_vm._s(_vm.SITE_CONFIG.skipass.ages.adults) + "år")]), _vm._v(" "), (_vm.SITE_CONFIG.skipass.ages.seniors) ? _c('th', [_c('b', [_vm._v(_vm._s(_vm.$t('general.ages.senior')))]), _c('br'), _vm._v(_vm._s(_vm.SITE_CONFIG.skipass.ages.seniors) + "år")]) : _vm._e(), _vm._v(" "), _c('th', [_c('b', [_vm._v(_vm._s(_vm.$t('skipass.cards.parents')))]), _c('br'), _vm._v(" ")])]), _vm._v(" "), _c('tbody', _vm._l((_vm.prices), function(price, key) {
    return (_vm.titles[key] && (price.youths || price.adults || price.parents)) ? _c('tr', [_c('td', {
      staticClass: "title"
    }, [_c('b', [_vm._v(_vm._s(_vm.titles[key]))])]), _vm._v(" "), _c('td', {
      staticClass: "special-price-wrapper"
    }, [(price.special_text) ? _c('span', {
      staticClass: "special-price"
    }, [_vm._v(_vm._s(price.special_text))]) : _vm._e()]), _vm._v(" "), (_vm.SITE_CONFIG.site !== 'branas' && _vm.SITE_CONFIG.site !== 'kungsberget') ? _c('td', {
      staticClass: "price"
    }, [(price.children) ? _c('span', [_vm._v(_vm._s(_vm._f("currency")(price.children.price)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "price"
    }, [(price.youths) ? _c('span', [_vm._v(_vm._s(_vm._f("currency")(price.youths.price))), (price.youths.asterisk) ? _c('span', [_vm._v(_vm._s(price.youths.asterisk))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "price"
    }, [(price.adults) ? _c('span', [_vm._v(_vm._s(_vm._f("currency")(price.adults.price))), (price.adults.asterisk) ? _c('span', [_vm._v(_vm._s(price.adults.asterisk))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.SITE_CONFIG.skipass.ages.seniors) ? _c('td', {
      staticClass: "price"
    }, [(price.seniors) ? _c('span', [_vm._v(_vm._s(_vm._f("currency")(price.seniors.price))), (price.seniors.asterisk) ? _c('span', [_vm._v(_vm._s(price.seniors.asterisk))]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.site === 'branas' || _vm.SITE_CONFIG.site === 'kungsberget') ? _c('td', {
      staticClass: "price"
    }, [(price.parents) ? _c('span', [_vm._v(_vm._s(_vm._f("currency")(price.parents.price))), (price.parents.asterisk) ? _c('span', [_vm._v(_vm._s(price.parents.asterisk))]) : _vm._e()]) : _vm._e()]) : _vm._e()]) : _vm._e()
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "padding"
  }, _vm._l((_vm.asterisks), function(asterisk) {
    return _c('p', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(asterisk.asterisk + ' ' + asterisk.text)
      }
    })])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17cee0c2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/SkipassPrices.vue
// module id = 921
// module chunks = 0